export default {
  title: "Auto Reply",
  addLabel: "Add Label",
  label: "Label",
  sort: "Sort",
  addAutoReply: "Add Auto Reply",
  selectTags: "Please select a label",
  message: {
    label: "Please add a label first",
    uploadImg: "Please upload an image",
  },
  form: {
    addReply: "Add Reply",
    addImg: "Add Image",
    serial: "Serial Number",
  },
};
